import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getUser, getToken } from '@verzekeringapp-mono/shared/src/state/selectors/user'
import { FC, PropsWithChildren } from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

export const AuthRoute: FC<PropsWithChildren> = ({ children }) => {
  const user = useSelector(getUser)
  const token = useAppSelector(getToken)

  if (user && token) {
    return <Navigate to='/overzicht' />
  }

  return children
}
